import React, { useEffect, useState } from "react";
import axios from "axios";
import ElementForm from "./ElementForm";
import Association from "./Association";
import { Navigate } from "react-router-dom";


const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiIGLS = `${protocole}${host}:${port}`

const typeElementAAssocierParType = {
  inscription: [ 'donnee', 'document', 'collection'],
  document: [ 'donnee', 'inscription', 'auteur'],
  donnee: [ 'auteur', 'document', 'inscription'],
  collection: [ 'inscription'],
  auteur: [ 'donnee', 'document'],
}

// ElementEdit Component
const ElementEdit = (params) => {
  const {typeElement, elem} = params
  const [fini, setFini] = useState(false)
  const urlElement = `/${typeElement}/${elem.id}`

  useEffect(() => {
  }, [typeElement, elem])

  //onSubmit handler
  const onSubmit = (elementCourant) => {
    console.log("Modif")
    //console.log(elementCourant)

    const token = localStorage.getItem('token-access') ? localStorage.getItem('token-access') : ""
    const headers = {
      'accept': 'application/json',
      'x-access-token': token
     }
     // ! indispensable pour les fichiers
    if (typeElement === 'donnee' ) {
      headers['content-type']= 'multipart/form-data'
      if (elementCourant.contexte){
        elementCourant.contexte = elementCourant.contexte.join("-")
      }
    }
    console.log(`${apiIGLS}/${typeElement}/${elem.id}`)
    console.log("Les elements a sauvegarder")
    console.log(elementCourant)

    axios({
      //method post au lieu de put pour le file upload...
      method: 'put',
      url:  `${apiIGLS}/${typeElement}/${elem.id}`,
      headers: headers,
      data: elementCourant
    })
    .then((reponse) => {
      if (reponse.status === 200) {
        setFini(true)
        //alert(typeElement + " mis à jour");
      }
      else Promise.reject()
    })
    .catch((erreur) => {
      if (erreur.response.status === 401){
        alert("Une erreur d'authentification a eu lieu lors de la modification"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
          console.log(erreur.response)
      } else if (erreur.response.status === 403){
        alert("Une erreur d'autorisation a eu lieu lors de la modification"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
          console.log(erreur.response)
      } else {
        alert("Une erreur a eu lieu lors de la modification"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.message)
      }
    })

  };

  return (
    <>
      {!fini && <ElementForm
      typeAction="Modifier"
      initialValues={elem}
      typeElement={typeElement}
      onSubmit={onSubmit}
      />}
      {!fini && typeElementAAssocierParType[typeElement].map(
        monType =>
          <Association
            key={`${monType}_${elem.id}`}
            id={elem.id}
            typeElementAAssocier={monType}
            typeElement={typeElement}
            />
      )}
     {fini && <Navigate to={urlElement} replace={true}/>}
    </>
  )
}
export default ElementEdit